import React, { useState, useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { Spinner, Container, Row, Col } from 'react-bootstrap';
import Alert from 'react-bootstrap/Alert';
import { isEmpty } from 'lodash';
//hooks
import { useIntersectionObserver } from 'react-intersection-observer-hook';
import useDebouncedCallback from 'utils/customHooks/useDebouncedCallback';
//api
import { searchFilterProduct } from 'api/products';
// components
import ItemList from 'components/itemList/item';
import FilterProductBooks from 'components/filters/filterProductBooks';

const DynamicFilter = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [contentListBottom, { entry }] = useIntersectionObserver();
  const isVisible = entry && entry.isIntersecting;
  
  const [querySearch, setQuerySearch] = useState({});
  const [queryResults, setQueryResults] = useState({});
  const [page, setPage] = useState(1);

  const { type } = useParams();

  let path = window.location.pathname.split('/')[2];

  useEffect(() => {
    // initial load
    (async () => {
      setIsLoading(true);
      try {
        const { data } = await searchFilterProduct({ page, type });
        setQueryResults(data);
      } catch (e) {}
      setIsLoading(false);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    goUp();
  }, []);

  useEffect(() => {
    // infinite scrolling
    (async () => {
      if (isVisible && !isLoading && queryResults?.next) {
        const nextPage = page + 1;
        try {
          const { data } = await searchFilterProduct({
            page: nextPage,
            ...querySearch,
            type,
          });
          setQueryResults(prev => ({
            results: [...prev.results, ...data.results],
            next: data.next,
            count: data.count,
          }));
          setPage(nextPage);
        } catch (e) {}
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isVisible]);

  const updateQuery = useDebouncedCallback(async (query) => {
    try {
      setIsLoading(true);
      const { data } = await searchFilterProduct(query);
      setQuerySearch(query);
      setQueryResults(data);
      setPage(1);
    } catch (e) {}
    setIsLoading(false);
  }, 500);

  //render
  const renderFilterProducts = useMemo(() => {
    return <FilterProductBooks filterProductsHandle={updateQuery} />;
  }, [updateQuery]);

  const goUp = () => {
    window.scrollTo(0, 0);
  };

  return (
    <div className="content">
      <div className="container-fluid">
        <Row>
          <Col md={12}>
            <h1 className="page-title static-title" style={{ textTransform: 'capitalize' }}>
              {path}
            </h1>
          </Col>
        </Row>
        <Container fluid>
          <Row className="mb-4">
            <Col lg={3} md={4} sm={12} xs={12}>
              {renderFilterProducts}
            </Col>
            <Col lg={9} md={8}>
              <Alert variant={'secondary'} className="mt-4 mt-md-0 mx-0 mx-md-3">
                Se encontraron {queryResults ? queryResults.count : 0} resultados
              </Alert>
              <Row>
                {isLoading ? (
                  <Col md={12} lg={12} sm={12} style={{ marginTop: 55 }}>
                    <h5 className="text-center">
                      {' '}
                      <Spinner animation="border" role="status"></Spinner>
                    </h5>
                  </Col>
                ) : (
                  queryResults &&
                  !isEmpty(queryResults.results) &&
                  queryResults?.results?.map((item, i) => (
                    <Col xl={3} lg={4} md={6} sm={6} key={i} style={{ marginTop: 5 }}>
                      <ItemList key={i} data={item} />
                    </Col>
                  ))
                )}
                {queryResults?.next !== null && !isLoading && (
                  <Col md={12} lg={12} sm={12} style={{ marginTop: 55 }}>
                    <h5 className="text-center">
                      {' '}
                      <Spinner animation="border" role="status"></Spinner>
                    </h5>
                  </Col>
                )}
              </Row>
              <div className="content-bottom"  ref={contentListBottom}></div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};
export default DynamicFilter;